import { AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Native-Angular port of the AngularJS `translate` ATTRIBUTE directive form
 * — `<span translate="flipto.account.GuestsAndFriends"></span>` sets the
 * host element's textContent to the translated value. (The PIPE form
 * `{{ 'key' | translate }}` is covered by `LegacyTranslatePipe`; this
 * complements it for the attribute syntax used liberally in audiences's
 * segment-nav labels.)
 *
 * Now resolves through the native ngx `TranslateService.instant` (the WS2
 * translate sweep drained the AngularJS `$translate` `$injector` bridge); the
 * AngularTranslateCompatParser keeps the value byte-identical to
 * angular-translate incl. `$sanitize` ([[project_account_ngx_translate_gap]]).
 *
 * Applied via innerHTML, NOT textContent: angular-translate's directive form
 * rendered with `element.html(value)`, so the parser's `$sanitize` entity
 * escapes (`&` -> `&amp;`) decoded back on paint. textContent painted them
 * literally ("GUESTS &AMP; FRIENDS" on the audiences segment nav).
 */
@Directive({
    selector: '[translate]',
    standalone: false
})
export class TranslateAttrDirective implements AfterViewInit, OnChanges {
  @Input('translate') key: string | undefined;

    private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
    private readonly translate = inject(TranslateService);

  ngAfterViewInit(): void {
    this.applyTranslation();
  }

  ngOnChanges(_changes: SimpleChanges): void {
    if (this.elementRef.nativeElement.isConnected) this.applyTranslation();
  }

  private applyTranslation(): void {
    if (!this.key) return;
    this.elementRef.nativeElement.innerHTML = this.translate.instant(this.key);
  }
}
